export const RaikoLeafletIranProvinces = {
    Tehran: {name: "Tehran", lat: 35.6892, lng: 51.3890, zoom: 11, point: [35.6892, 51.3890]},
    Alborz: {name: "Alborz", lat: 35.9960, lng: 50.9289, zoom: 11, point: [35.9960, 50.9289]},
    Qom: {name: "Qom", lat: 34.6399, lng: 50.8759, zoom: 11, point: [34.6399, 50.8759]},
    Qazvin: {name: "Qazvin", lat: 36.2688, lng: 50.0041, zoom: 10, point: [36.2688, 50.0041]},
    Gilan: {name: "Gilan", lat: 37.2808, lng: 49.5832, zoom: 9, point: [37.2808, 49.5832]},
    Mazandaran: {name: "Mazandaran", lat: 36.5659, lng: 52.3000, zoom: 9, point: [36.5659, 52.3000]},
    Golestan: {name: "Golestan", lat: 37.2890, lng: 55.1633, zoom: 9, point: [37.2890, 55.1633]},
    EastAzerbaijan: {name: "East Azerbaijan", lat: 38.0800, lng: 46.2919, zoom: 9, point: [38.0800, 46.2919]},
    WestAzerbaijan: {name: "West Azerbaijan", lat: 37.5483, lng: 45.0670, zoom: 9, point: [37.5483, 45.0670]},
    Ardabil: {name: "Ardabil", lat: 38.2498, lng: 48.2933, zoom: 10, point: [38.2498, 48.2933]},
    Zanjan: {name: "Zanjan", lat: 36.6760, lng: 48.4787, zoom: 10, point: [36.6760, 48.4787]},
    Kurdistan: {name: "Kurdistan", lat: 35.3145, lng: 46.9988, zoom: 10, point: [35.3145, 46.9988]},
    Kermanshah: {name: "Kermanshah", lat: 34.3142, lng: 47.0650, zoom: 10, point: [34.3142, 47.0650]},
    Hamadan: {name: "Hamadan", lat: 34.7980, lng: 48.5146, zoom: 11, point: [34.7980, 48.5146]},
    Markazi: {name: "Markazi", lat: 34.5553, lng: 49.8547, zoom: 10, point: [34.5553, 49.8547]},
    Lorestan: {name: "Lorestan", lat: 33.4878, lng: 48.3550, zoom: 10, point: [33.4878, 48.3550]},
    Ilam: {name: "Ilam", lat: 33.6370, lng: 46.4227, zoom: 11, point: [33.6370, 46.4227]},
    Khuzestan: {name: "Khuzestan", lat: 31.3183, lng: 48.6706, zoom: 9, point: [31.3183, 48.6706]},
    ChaharmahalBakhtiari: {
        name: "Chaharmahal and Bakhtiari",
        lat: 32.3276,
        lng: 50.8539,
        zoom: 10,
        point: [32.3276, 50.8539]
    },
    Isfahan: {name: "Isfahan", lat: 32.6546, lng: 51.6680, zoom: 10, point: [32.6546, 51.6680]},
    Yazd: {name: "Yazd", lat: 31.8974, lng: 54.3569, zoom: 11, point: [31.8974, 54.3569]},
    Fars: {name: "Fars", lat: 29.5918, lng: 52.5837, zoom: 9, point: [29.5918, 52.5837]},
    Bushehr: {name: "Bushehr", lat: 28.9234, lng: 50.8203, zoom: 10, point: [28.9234, 50.8203]},
    Hormozgan: {name: "Hormozgan", lat: 27.1832, lng: 56.2666, zoom: 8, point: [27.1832, 56.2666]},
    Kerman: {name: "Kerman", lat: 30.2839, lng: 57.0834, zoom: 13, point: [30.2839, 57.0834]},
    SistanBaluchestan: {name: "Sistan and Baluchestan", lat: 28.5000, lng: 61.0000, zoom: 7, point: [28.5000, 61.0000]},
    KohgiluyehBoyerAhmad: {
        name: "Kohgiluyeh and Boyer-Ahmad",
        lat: 30.6509,
        lng: 51.6052,
        zoom: 10,
        point: [30.6509, 51.6052]
    },
    NorthKhorasan: {name: "North Khorasan", lat: 37.4719, lng: 57.1013, zoom: 9, point: [37.4719, 57.1013]},
    RazaviKhorasan: {name: "Razavi Khorasan", lat: 36.2970, lng: 59.6060, zoom: 12, point: [36.2970, 59.6060]},
    SouthKhorasan: {name: "South Khorasan", lat: 32.5176, lng: 59.1042, zoom: 9, point: [32.5176, 59.1042]},
    Semnan: {name: "Semnan", lat: 35.5770, lng: 53.3940, zoom: 9, point: [35.5770, 53.3940]}
};
